<script lang="ts" setup>
import { defineComponent, onMounted } from "vue";
import { SidebarMenu } from "@/modules/sideBarMenu";
import { GlobalSnackbar } from "@/modules/globalSnackbar";
import { useAuthStore } from "@/store/auth.store";
import { storeToRefs } from "pinia";

defineComponent({
  name: "MainLayout",
});

const { fetchUserProfile } = useAuthStore();
const { isLoaded } = storeToRefs(useAuthStore());

onMounted(async () => {
  await fetchUserProfile();
});
</script>

<template>
  <div class="main-layout">
    <SidebarMenu v-if="isLoaded" />
    <div class="main-layout__content">
      <RouterView v-if="isLoaded" />
    </div>
    <GlobalSnackbar />
  </div>
</template>

<style lang="scss" scoped>
.main-layout {
  display: flex;
  width: 100%;
  height: 100%;

  &__content {
    width: 100%;
    padding: 0 0 32px 260px;
  }
}
</style>
